import type { ReactNode } from 'react'

export type ModalProps = {
  children?: ReactNode
  className?: string
  onOpenModal?: () => void
  onCloseModal?: () => void
}

export enum MODAL_LISTENERS {
  OPEN = 'OPEN_MGT_MODAL',
  CLOSE = 'CLOSE_MGT_MODAL'
}
